import {forwardRef, useState} from "react";
import newsIndexImage from "../../assets/images/news/ss.jpg";
import {mobileImage} from "../mobileAssets";

const NEWS_PAGE_SIZE = 4;

function formatNewsDate(item) {
    const value = item.datetime || item.date || "";
    const match = String(value).match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
    return match ? `${match[1]}.${String(match[2]).padStart(2, "0")}.${String(match[3]).padStart(2, "0")}` : value;
}

const NewsScreen = forwardRef(function NewsScreen({newsItems, isLoading, onOpenArticle}, ref) {
    const [activeTab, setActiveTab] = useState("latest");
    const [activePage, setActivePage] = useState(1);
    const visibleNewsItems = activeTab === "notice"
        ? newsItems.filter(function (item) { return item.tab === "notice"; })
        : newsItems;
    const totalPages = Math.max(1, Math.ceil(visibleNewsItems.length / NEWS_PAGE_SIZE));
    const currentPage = Math.min(activePage, totalPages);
    const pageItems = visibleNewsItems.slice((currentPage - 1) * NEWS_PAGE_SIZE, currentPage * NEWS_PAGE_SIZE);

    const handleTabChange = function (tab) {
        setActiveTab(tab);
        setActivePage(1);
    };

    return (
        <div ref={ref} className="page_news mobile-section-page">
            <p className="mobile-quality-note">*游戏研发中，非最终品质。</p>
            <div className="banner"><img src={newsIndexImage} alt="新闻主图"/></div>
            <div className="news_box">
                <div className="mobile-news-tabs">
                    <button type="button" className={activeTab === "latest" ? "on" : ""} onClick={() => handleTabChange("latest")}>最新</button>
                    <button type="button" className={activeTab === "notice" ? "on" : ""} onClick={() => handleTabChange("notice")}>公告</button>
                </div>
                <div className="fade">
                    <div className="item">
                        {isLoading ? <div className="mobile-news-state">新闻加载中...</div> : pageItems.length > 0 ? pageItems.map(function (item) {
                            return <div className="label" key={item.id || item.title}><a href="#article" onClick={(event) => { event.preventDefault(); onOpenArticle(item); }}><div><span>{item.category || "公告"}</span><p>{item.title}</p></div><em>{formatNewsDate(item)}</em></a></div>;
                        }) : <div className="mobile-news-state">{activeTab === "notice" ? "暂无公告" : "暂无新闻"}</div>}
                    </div>
                </div>
                {!isLoading && visibleNewsItems.length > 0 ? <div className="fy" aria-label="新闻分页">
                    <button type="button" disabled={currentPage <= 1} onClick={() => setActivePage(function (page) { return Math.max(1, page - 1); })} aria-label="上一页"><img src={mobileImage("ones_10.png")} alt="上一页"/></button>
                    <button type="button" disabled={currentPage >= totalPages} onClick={() => setActivePage(function (page) { return Math.min(totalPages, page + 1); })} aria-label="下一页"><img src={mobileImage("ones_13.png")} alt="下一页"/></button>
                </div> : null}
            </div>
        </div>
    );
});

export default NewsScreen;